import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Nu mai importa LanguageDetector, ca să nu detecteze automat limba

import translationRO from "./locales/ro/translation.json";
import translationEN from "./locales/en/translation.json";

const resources = {
  ro: { translation: translationRO },
  en: { translation: translationEN },
};

i18n
  // .use(LanguageDetector)  // scoate asta
  .use(initReactI18next)
  .init({
    resources,
    lng: "ro",            // forțezi limba română
    fallbackLng: "ro",
    interpolation: { escapeValue: false },
  });

export default i18n;
